import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Footer from '../components/Footer';

const pillars = [
  {
    title: 'Movement & Physical Health',
    description:
      'Gentle exercise plans, sleep hygiene coaching and occupational therapy programmes designed to rebuild strength, proprioception and confidence.',
    examples: ['Daily activity prompts and sensory circuits', 'Outdoor adventures and walking therapy', 'Links with local sports and community clubs']
  },
  {
    title: 'Nutrition & Self-Care',
    description:
      'Dietitians, therapists and residential chefs work together so young people learn about nourishment, hydration and routine. We focus on restoring a positive relationship with food.',
    examples: ['Meal planning and cookery sessions', 'Support around disordered eating patterns', 'Mindful eating and body image workshops']
  },
  {
    title: 'Mind, Connection & Purpose',
    description:
      'Lifestyle Medicine integrates therapeutic conversations with creative outlets, volunteering and education. We help young people notice what settles them and what sparks passion.',
    examples: ['Breath work, yoga and grounding tools', 'Digital wellbeing coaching', 'Community participation and aspiration planning']
  }
];

const LifestyleMedicine = () => (
  <div className="LifestyleMedicine bg-white">
    <Header />
    <div className="mt-32 sm:mt-36 lg:mt-32">
      <Hero
        image="/assets/images/tc-heart-hands.jpeg"
        position="center"
        heightClass="min-h-[45vh] sm:min-h-[55vh] lg:min-h-[70vh]"
      />

      <section className="bg-white py-16 px-6 lg:px-12">
      <div className="max-w-6xl mx-auto">
        <p className="text-sm uppercase tracking-[0.3em] text-[#2f4c74] mb-4">Therapy Services</p>
        <h1 className="text-4xl md:text-6xl font-light text-[#2b3d57] mb-6">Lifestyle Medicine</h1>
        <p className="text-xl text-[#2b3d57] leading-relaxed max-w-4xl mb-4">
          Lifestyle Medicine blends clinical insight with everyday habits. By prioritising sleep,
          movement, nutrition, relationships and purpose we create sustainable change that supports
          the therapy young people undertake with us.
        </p>
        <p className="text-[#2b3d57] leading-relaxed max-w-4xl">
          Programmes are co-created with young people and can be commissioned as part of their care
          plan or as a standalone package for schools and partner organisations.
        </p>
      </div>
    </section>

    <section className="bg-[#f2f4f7] py-16 px-6 lg:px-12">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-8">
        {pillars.map((pillar) => (
          <div key={pillar.title} className="bg-white rounded-lg shadow-sm p-8 flex flex-col">
            <h2 className="text-2xl font-light text-[#2b3d57] mb-4">{pillar.title}</h2>
            <p className="text-[#2b3d57] mb-4 leading-relaxed">{pillar.description}</p>
            <ul className="list-disc list-inside text-[#2b3d57] space-y-2 mt-auto">
              {pillar.examples.map((example) => (
                <li key={example}>{example}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>

    <section className="bg-white py-16 px-6 lg:px-12">
      <div className="max-w-5xl mx-auto">
        <div className="bg-[#2b3d57] text-white rounded-lg p-8">
          <h3 className="text-3xl font-light mb-4">Lifestyle Reviews</h3>
          <p className="leading-relaxed mb-6">
            Regular reviews track progress against wellbeing goals and capture the young person’s own
            reflections. These reviews inform placement meetings and help local authorities evidence
            outcomes.
          </p>
          <a
            href="mailto:Info@testacare.co.uk"
            className="inline-flex items-center justify-center rounded-full border-2 border-white px-6 py-2 text-white hover:bg-white hover:text-[#2b3d57] transition"
          >
            Explore programmes
          </a>
        </div>
      </div>
    </section>

      <Footer />
    </div>
  </div>
);

export default LifestyleMedicine;



